import { numberToTextEng, numberToTextSwe } from '@fora-monorepo/string-utils';

export const numberToText = (value: number, language: string): string => {
  return language !== 'sv' ? numberToTextEng(value) : numberToTextSwe(value);
};
